                        <template>
    <div class="col-12 col-lg-9 mt-4 mt-lg-0">
                                <div class="card">
                                    <div class="card-header">
                                        <h5>Invoice and Payment History Search</h5>
                                    </div>
                                    <div class="card-divider"></div>
                                    <div class="card-body card-body--padding--1">
                                        <div><strong><p>Search for Invoice Details and Payment History </p></strong></div>
                                        <div class="row no-gutters">										
                                            <div class="col-12 col-lg-7 col-xl-6">											
                                                <div class="form-group">
                                                    <label for="profile-first-name">Invoice Number</label>
                                                    <input type="text" class="form-control" id="profile-first-name" placeholder="Invoice Number">
                                                </div>
                                                <div class="form-group">
                                                    <label for="profile-last-name">Check Number</label>
                                                    <input type="text" class="form-control" id="profile-last-name" placeholder="Check Number">
                                                </div>
                                                <div class="form-group">
                                                    <label for="profile-email">Payment</label>
                                                    <input type="email" class="form-control" id="profile-email" placeholder="Payment Amount">
                                                </div>
                                                <div class="order-header__subtitle">Leave blank to show entire Payment History</div>
                                                    <div class="block-space--layout--divider-15"></div>
                                                <div class="form-group mb-0">
                                                    <a href="/account-payment-history" class="btn btn-md btn-primary">Search</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>